import React, { useRef } from 'react';
import { SectionHeader } from '../common/SharedComponents';
import Map from './Map';

const Demographics = () => {
    const mapRef = useRef();
    Map(mapRef);

    return (
        <>
            <SectionHeader title='Demographics' />
            <div style={{ paddingLeft: '20px', height: '25px' }}>
                Click on map or enter address to display demographic data (USA only)
            </div>
            <div
                ref={mapRef}
                style={{
                    padding: '0',
                    margin: '0',
                    height: 'calc(100% - 150px)',
                    width: '100%',
                }}
            ></div>
        </>
    );
};

export default Demographics;
